import { RoomV2EntityRaw } from "@common/domain";
import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { Action, createReducer, on } from "@ngrx/store";
import { RoomsListActions } from "../actions";

export const ROOMS_LIST_FEATURE_KEY = "roomsList";

export interface RoomsListState extends EntityState<RoomV2EntityRaw> {
  isLoading: boolean;
}

export const roomsListAdapter: EntityAdapter<RoomV2EntityRaw> =
  createEntityAdapter<RoomV2EntityRaw>({
    sortComparer: (lhs, rhs) => {
      if (lhs.startAt && rhs.startAt) {
        return lhs.startAt - rhs.startAt;
      }

      if (!lhs.startAt && rhs.startAt) {
        return 1;
      }

      if (lhs.startAt && !rhs.startAt) {
        return -1;
      }

      return rhs.id - lhs.id;
    }
  });

const initialState: RoomsListState = roomsListAdapter.getInitialState({
  isLoading: false
});

const reducer = createReducer(
  initialState,
  on(
    RoomsListActions.roomsList,
    RoomsListActions.roomCreate,
    RoomsListActions.roomDelete,
    RoomsListActions.roomUpdate,
    (state) => {
      return {
        ...state,
        isLoading: true
      };
    }
  ),
  on(RoomsListActions.roomsListSuccess, (state, { rooms }) =>
    roomsListAdapter.addMany(
      rooms.map((_) => _.toJSON()),
      {
        ...state,
        isLoading: false
      }
    )
  ),
  on(
    RoomsListActions.roomsListFailure,
    RoomsListActions.roomCreateFailure,
    RoomsListActions.roomDeleteFailure,
    RoomsListActions.roomUpdateFailure,
    (state) => {
      return {
        ...state,
        isLoading: false
      };
    }
  ),
  on(RoomsListActions.roomCreateSuccess, (state, { room }) =>
    roomsListAdapter.addOne(room.toJSON(), {
      ...state,
      isLoading: false
    })
  ),
  on(RoomsListActions.roomDeleteSuccess, (state, { roomDeleteCmd }) =>
    roomsListAdapter.removeOne(roomDeleteCmd.value.roomId, {
      ...state,
      isLoading: false
    })
  ),
  on(RoomsListActions.roomUpdateSuccess, (state, { room }) =>
    roomsListAdapter.updateOne(
      {
        id: room.value.id,
        changes: room.toJSON()
      },
      {
        ...state,
        isLoading: false
      }
    )
  )
);

export function roomsListReducer(
  state: RoomsListState | undefined,
  action: Action
) {
  return reducer(state, action);
}
